export interface StartPasswordResetResponse {
  success: boolean;
}

export const startPasswordReset = async (username: string): Promise<StartPasswordResetResponse> => {
  try {
    const response = await fetch('/password/reset/start', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      referrerPolicy: 'strict-origin-when-cross-origin',
      body: JSON.stringify({ UserName: username }),
    });

    if (!response.ok) {
      return {
        success: false,
      };
    }

    const result = await response.json();

    return {
      success: !!result,
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    return {
      success: false,
    };
  }
};
